<div class="accordion__container">
  <form [formGroup]="group">
    <div class="accordion__grid">
      <div>
        <mat-form-field>
          <mat-label>Salutation</mat-label>
          <mat-select formControlName="salutation" id="salutation" title="Salutation">
            @for (type of salutations; track $index) {
              <mat-option [value]="type.key">{{ type.value }}</mat-option>
            }
          </mat-select>
          <mat-error comFormMessageName="salutation">Please select a salutation</mat-error>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>First Name</mat-label>
          <input matInput formControlName="firstName" id="firstName" type="text" title="First Name" />
          <mat-error comFormMessageName="firstName">Please enter a first name</mat-error>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>Last Name</mat-label>
          <input matInput formControlName="lastName" id="lastName" type="text" title="Last Name" />
          <mat-error comFormMessageName="lastName">Please enter a last name</mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="accordion__buttons">
      @if (group.disabled) {
        <button mat-raised-button (click)="edit(group)" [disabled]="!canEdit">EDIT</button>
      }
      @if (isError) {
        <div [innerHtml]="errorMessages | arrayToList"></div>
      }
      @if (!group.disabled) {
        <button mat-raised-button (click)="cancel(group)">CANCEL</button>
        <button mat-raised-button [disabled]="!group.valid" (click)="save(group.value)">UPDATE</button>
      }
    </div>
  </form>
</div>
